import * as yup from 'yup';

import { validateEmail } from 'src/utils/validators/validate-email';

import { roommateDataKeys } from './constants';

const errorMessages = {
    first_name: {
        required: 'your_details_form_first_name_required',
        invalid: 'your_details_form_first_name_invalid',
    },
    last_name: {
        required: 'your_details_form_last_name_required',
        invalid: 'your_details_form_last_name_invalid',
    },
    email: {
        required: 'your_details_form_email_required',
        invalid: 'your_details_form_email_invalid',
    },
};

export const roommateDetailsSchema = yup.object().shape({
    roommates: yup.array().of(
        yup.object().shape({
            [roommateDataKeys.first_name]: yup
                .string()
                .required(errorMessages.first_name.required)
                .max(40, errorMessages.first_name.invalid),
            [roommateDataKeys.last_name]: yup
                .string()
                .required(errorMessages.last_name.required)
                .max(40, errorMessages.last_name.invalid),
            [roommateDataKeys.email]: yup
                .string()
                .lowercase()
                .required(errorMessages.email.required)
                .test({ message: errorMessages.email.invalid, test: validateEmail }),
        })
    ),
});
